import http from './httpService';
import config from '../configs/config.js';
import references from '../configs/reference.json';
import { largeDate, monthYear } from '../utils/constants';
import qs from 'qs';

const apiEndPoint = config.apiEndPoint + '/anomaly';
const trendEndPoint = config.apiEndPoint + '/trend';
const predictiveTrendEndPoint = config.apiEndPoint + '/predictive_trend';
const networkEndPoint = config.apiEndPoint + '/networkgraph';

function generateURL(path) {
  return `${apiEndPoint}/${path}`;
}

//1. card API
export async function getAnomalyList(skip = 0, limit = 50, filters = {}) {
  let params = { skip: skip, limit: limit };
  Object.keys(filters).map((x) => (params[x] = filters[x]));
  let anomalies = await http.get(apiEndPoint, {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
  anomalies.data.forEach(function (data) {
    data.kpi_name = data.aan_name;
    data.aan_value_new = data.aan_value;
    data.aan_month = new Date(data.aan_date).toLocaleString(
      undefined,
      monthYear
    );
  });
  references.forEach(function (val) {
    anomalies.data.forEach(function (data, i) {
      if (val.from === data.kpi_name) {
        data.kpi_direction = val.direction;
        data.kpi_format = val.format;
      }
      data.kpi_name = data.kpi_name.replaceAll(val.from, val.to);
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  //console.log('All Anomalies API', anomalies);
  return anomalies;
}

//2. Tile API
export async function getAnomalyByID(id) {
  let anomaly = await http.get(generateURL(id));
  anomaly.data.kpi_name = anomaly.data.aan_name;
  //converting date from UTC to IST
  let last_upd = new Date(anomaly.data.last_updated + 'Z');
  anomaly.data.last_updated = last_upd.toLocaleString(undefined, largeDate);
  //rename kpi name
  references.forEach(function (val) {
    if (val.from === anomaly.data.kpi_name) {
      anomaly.data.kpi_direction = val.direction;
      anomaly.data.kpi_format = val.format;
    }
    anomaly.data.kpi_name = anomaly.data.kpi_name.replaceAll(val.from, val.to);
    anomaly.data.inference = anomaly.data.inference.replaceAll(
      val.from,
      val.to
    );
  });
  //console.log('Anomaly ID API', anomaly);
  return anomaly;
}

//3. Status Update API
export async function anomalyStatusUpdate(id, status) {
  const body = { status: status };
  let anomaly = await http.put(generateURL(id), body);
  //console.log('Status Update API', anomaly);
  return anomaly;
}

//4. Line API
export async function getTrendData(anomaly, type = 'rca', predictive = false) {
  let query = trendEndPoint;
  let data = await http.get(query, {
    params: {
      alert_id: anomaly.anomaly_id,
      rca_id:
        Object.keys(anomaly).includes('rca_id') && type === 'rca'
          ? anomaly.rca_id
          : ''
    }
  });
  let { data: predictive_data } =
    anomaly.anomaly_type === 'predictive' || predictive
      ? await http.get(predictiveTrendEndPoint, {
          params: {
            alert_id: anomaly.anomaly_id,
            rca_id:
              Object.keys(anomaly).includes('rca_id') && type === 'rca'
                ? anomaly.rca_id
                : ''
          }
        })
      : { data: [] };
  const temp_data = { ...data };
  temp_data.data = [...predictive_data, ...data.data];
  temp_data.count = predictive_data.length;
  // console.log('Trend API', temp_data);
  return temp_data;
}

//5. Stacked Bar API
export async function getStackedBar() {
  let data = await http.get(generateURL('severity'));
  //console.log('Stacked Bar API', data);
  return data;
}

//6. Alert Filter API
export async function getAlertFilters(column, filters) {
  let params = { column_name: column };
  Object.keys(filters).map((x) => (params[x] = filters[x]));
  let data = await http.get(generateURL('filter'), {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
  //console.log('Alert Filter API', data);
  return data;
}

//7. Get RCAs by anomaly id
export async function getRCA(id) {
  let rcas = await http.get(generateURL('rca/' + id));
  rcas.data.forEach(function (data) {
    data.aan_kpi_name = data.aan_name;
    data.kpi_name = data.rc_name;
    data.rc_kpi_name = data.rc_name;
    data.rc_value_new = data.rc_value;
    data.aan_value_new = data.aan_value;
  });
  references.forEach(function (val) {
    rcas.data.forEach(function (data, i) {
      if (val.from === data.rc_name) {
        data.rc_direction = val.direction;
        data.rc_format = val.format;
      }
      if (val.from === data.aan_name) {
        data.aan_direction = val.direction;
        data.aan_format = val.format;
      }
      data.aan_kpi_name = data.aan_kpi_name.replaceAll(val.from, val.to);
      data.rc_kpi_name = data.rc_kpi_name.replaceAll(val.from, val.to);
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  //console.log('RCA API', rcas);
  return rcas;
}

//8. Get impacts by anomaly id
export async function getImpact(id) {
  let impacts = await http.get(generateURL('impact/' + id));
  references.forEach(function (val) {
    impacts.data.forEach(function (data, i) {
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  //console.log('Impact API', impacts);
  return impacts;
}

//9. Get RCAs by anomaly id
export async function getNetworkData(id) {
  let network = await http.get(networkEndPoint + '/' + id);
  references.forEach(function (val) {
    network.data.nodes.forEach(function (data, i) {
      data.KPIlabel = data.KPIlabel.replaceAll(val.from, val.to);
    });
  });
  //console.log('Network Graph API', network);
  return network;
}

//10. Get similar alerts
export async function getSimilarAlerts(id) {
  let alerts = await http.get(generateURL('similar/' + id));
  references.forEach(function (val) {
    alerts.data.forEach(function (data, i) {
      data.inference = data.inference.replaceAll(val.from, val.to);
    });
  });
  //console.log('Similar Alerts API', alerts);
  return alerts;
}
